import React from 'react';
import { Link } from 'react-router-dom';
import { Sun, Mail, Phone, MapPin, Facebook, Instagram, Linkedin } from 'lucide-react';
import { companyInfo } from '../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="space-y-4">
            <div className="flex items-center space-x-2">
              <div className="bg-gradient-to-br from-emerald-500 to-teal-600 p-2 rounded-lg">
                <Sun className="h-6 w-6 text-white" />
              </div>
              <span className="text-2xl font-bold text-white">W3Solar</span>
            </div>
            <p className="text-sm text-gray-400">
              Soluções em energia solar fotovoltaica para residências e empresas em todo o Brasil.
            </p>
            <div className="flex space-x-3">
              <a
                href={companyInfo.social.facebook}
                className="p-2 bg-gray-800 rounded-lg hover:bg-emerald-600 transition-colors"
                aria-label="Facebook"
              >
                <Facebook className="h-5 w-5" />
              </a>
              <a
                href={companyInfo.social.instagram}
                className="p-2 bg-gray-800 rounded-lg hover:bg-emerald-600 transition-colors"
                aria-label="Instagram"
              >
                <Instagram className="h-5 w-5" />
              </a>
              <a
                href={companyInfo.social.linkedin}
                className="p-2 bg-gray-800 rounded-lg hover:bg-emerald-600 transition-colors"
                aria-label="LinkedIn"
              >
                <Linkedin className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Links Rápidos</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm hover:text-emerald-400 transition-colors">
                  Início
                </Link>
              </li>
              <li>
                <Link to="/servicos" className="text-sm hover:text-emerald-400 transition-colors">
                  Serviços
                </Link>
              </li>
              <li>
                <Link to="/projetos" className="text-sm hover:text-emerald-400 transition-colors">
                  Projetos
                </Link>
              </li>
              <li>
                <Link to="/calculadora" className="text-sm hover:text-emerald-400 transition-colors">
                  Calculadora Solar
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-sm hover:text-emerald-400 transition-colors">
                  FAQ
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-white font-semibold mb-4">Serviços</h3>
            <ul className="space-y-2 text-sm">
              <li className="hover:text-emerald-400 transition-colors cursor-pointer">
                Energia Solar Residencial
              </li>
              <li className="hover:text-emerald-400 transition-colors cursor-pointer">
                Energia Solar Comercial
              </li>
              <li className="hover:text-emerald-400 transition-colors cursor-pointer">
                Energia Solar Industrial
              </li>
              <li className="hover:text-emerald-400 transition-colors cursor-pointer">
                Manutenção de Sistemas
              </li>
              <li className="hover:text-emerald-400 transition-colors cursor-pointer">
                Consultoria Energética
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-white font-semibold mb-4">Contato</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <Phone className="h-5 w-5 text-emerald-500 flex-shrink-0 mt-0.5" />
                <span className="text-sm">{companyInfo.phone}</span>
              </li>
              <li className="flex items-start space-x-3">
                <Mail className="h-5 w-5 text-emerald-500 flex-shrink-0 mt-0.5" />
                <span className="text-sm">{companyInfo.email}</span>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin className="h-5 w-5 text-emerald-500 flex-shrink-0 mt-0.5" />
                <span className="text-sm">{companyInfo.address}</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm text-gray-400">
              © {currentYear} W3Solar. Todos os direitos reservados.
            </p>
            <div className="flex space-x-6 text-sm">
              <Link to="/privacidade" className="text-gray-400 hover:text-emerald-400 transition-colors">
                Política de Privacidade
              </Link>
              <Link to="/termos" className="text-gray-400 hover:text-emerald-400 transition-colors">
                Termos de Uso
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
